import { render } from "./OrderFormComponent.vue?vue&type=template&id=e97574a4"
import script from "./OrderFormComponent.vue?vue&type=script&lang=js"
export * from "./OrderFormComponent.vue?vue&type=script&lang=js"

import "./OrderFormComponent.vue?vue&type=style&index=0&id=e97574a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__